import { getTotalPrice } from '@shared/lib/money';
import {
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment,
	GdsServiceProductStatus,
	OrderAdditionalServiceGdsServiceServiceType,
	PassengerSelectedGdsServicesProductFragment
} from '@websky/graphql';
import { ServiceOptionItem } from '../../../ServiceSummary/types';

import { getActualProduct, getBaggageName } from '../../../ServiceSummary/utils';
import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';

export function baggageOptionItemFactory({
	key,
	travellerId,
	gdsServiceRfisc,
	count,
	confirmedCount,
	segmentsGroupsCount,
	gdsService,
	products = [],
	groupType = 'all',
	isLoading
}: {
	key: string;
	travellerId: string;
	gdsServiceRfisc?: string;
	count: number;
	confirmedCount: number;
	segmentsGroupsCount: number;
	gdsService: GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment;
	products?: PassengerSelectedGdsServicesProductFragment[];
	groupType?: 'booked' | 'confirmed' | 'all';
	isLoading?: boolean;
}): ServiceOptionItem {
	let actualCount = count;
	let actualProducts = products.filter(product => product.passengerId === travellerId);

	const serviceId = gdsService.id;
	const included = groupType === 'confirmed' || confirmedCount === count;

	if (groupType === 'booked') {
		actualCount = count - confirmedCount;
		actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Booked);
	} else if (groupType === 'confirmed') {
		actualCount = confirmedCount;
		actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Ticketed);
	}

	const price = getTotalPrice(actualProducts, product => product.price);

	const dCount = count - confirmedCount;

	return {
		id: serviceId,
		rfisc: gdsServiceRfisc,
		segment: key,
		count: actualCount,
		price,
		included,
		name: getBaggageName(gdsService, actualCount),
		status: getActualProduct(actualProducts)?.status,
		iconName: gdsService.baggageType,
		deleteMeta:
			groupType !== 'confirmed'
				? {
						serviceId: serviceId,
						passengerId: travellerId,
						segmentId: key,
						count: count - dCount,
						allowedSegments: gdsService.allowedSegments,
						type: OrderAdditionalServiceGdsServiceServiceType.Baggage,
						allSegments: key === ALL_SEGMENTS_KEY
				  }
				: null,
		isLoading
	};
}
